const RoleUtils = {
    getDependencies: async (permission, inverse, permissions, dependencies) => {
        const permissionList = [];
        for (const dependency of dependencies) {
            const [permissionParent, childPermissions] = Object.entries(dependency)[0];

            if (inverse) {
                if (permissionParent === permission) {
                    for (const childPermission of childPermissions) {
                        const matching = permissions.find(item => item.name === childPermission);
                        if (matching) {
                            permissionList.push(matching);
                        }
                    }
                }
            } else {
                if (childPermissions.includes(permission)) {
                    const matchingPermission = permissions.find(permission => permission.name === permissionParent);
                    if (matchingPermission) {
                        permissionList.push(matchingPermission);
                    }
                }
            }
        }

        return permissionList;
    }
};

export default RoleUtils;